<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5 left-content" style="padding-bottom: 0!important;">
        <div class="w-100 align-items-center justify-content-center px-5" style="color: white">
          <div class=" d-none d-block d-lg-flex align-items-center justify-content-center">
            <div class="d-none d-block" style="width: 630px">
              <b-row>
                <span class="font-large-4 font-weight-bolder">80%</span>
              </b-row>
              <b-row>
                <span class="font-medium-2 mt-1">
                  Các cuộc thảo luận về thương hiệu<br/>của bạn xảy ra bên ngoài kênh riêng<br/> của bạn.
                </span>
              </b-row>
              <b-row>
                <span class="font-medium-2 mb-2 mt-2">
                  Cùng <b></b> khám phá những dữ <br/> liệu internet bạn chưa biết tới.
                </span>
              </b-row>
            </div>
          </div>

          <div class="d-lg-flex align-items-center justify-content-center">
            <b-img
              fluid
              :src="imgUrl"
              style="width: 630px;height: 400px;"
              alt="Login V2"/>
          </div>
<!--          <div class="vx-row">-->
<!--            <div class="vx-col mt-2" style="margin:auto;">-->
<!--              <vs-button style="border-radius: 20px" color="primary" type="gradient" icon-pack="feather"-->
<!--                         icon="icon-chevron-right" @click="requestTrial">Yêu cầu dùng thử-->
<!--              </vs-button>-->
<!--            </div>-->
<!--          </div>-->

        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-3">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <div class="d-flex mb-2">
            <img src="@/assets/images/pages/base-logo.png">
            <h1 class="text-left text-title mt-1">Crawl Data System</h1>
          </div>
          <!-- <div class="mb-2">
            <b-button
              v-google-signin-button="clientId"
              style="width: 100%"
              variant="primary">
              <img src="//d1ayxb9ooonjts.cloudfront.net/8bc625062aeffa94729b9336243bed9d.svg" alt="Google" width="20" style="background-color: white;border-radius: 5px;">
              <span class="align-middle ml-1">Đăng nhập bằng Google</span>
            </b-button>
          </div>

          <b-card-text class="mb-5">
            Quý khách có thể dùng ngay tài khoản Google đã có để đăng nhập trực tiếp InfoCare (không cần tạo mới tài khoản
            InfoCare)
          </b-card-text> -->

          <!-- <div class="divider my-2">
            <div class="divider-text">
              hoặc Quý khách đã có tài khoản InfoCare
            </div>
          </div> -->

          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="loginAction">
              <!-- email -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-email">Tài khoản</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Tài khoản"
                  vid="email"
                  rules="required">
                  <b-form-input
                    id="login-email"
                    v-model="username"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="email@domain.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Mật khẩu</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Mật khẩu"
                  vid="password"
                  rules="required">
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null">
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"/>
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <b-form-checkbox
                    id="remember-me"
                    v-model="remember"
                    name="checkbox-1">
                    Ghi nhớ đăng nhập
                  </b-form-checkbox>
                  <!-- <b-link :to="{name:'page-send-forgot-forgot-password'}">
                    <span>
                      Quên mật khẩu?
                    </span>
                  </b-link> -->
                </div>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid">Đăng nhập</b-button>
            </b-form>
          </validation-observer>

          <!-- <b-card-text class="text-left mt-2 mb-0">
            <span>Quý khách vẫn muốn tạo tài khoản InfoCare?</span>
          </b-card-text>
          <b-card-text class=" mb-0">
            <b-link :to="{name:'create-new-account'}" class = "">
              <span>Tạo tài khoản mới</span>
            </b-link>
          </b-card-text> -->

        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>
<script src="https://apis.google.com/js/platform.js" async defer></script>
<script>
/* eslint-disable global-require */
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BAlert,
} from 'bootstrap-vue'
import {togglePasswordVisibility} from '@core/mixins/ui/forms'
import GoogleLogin from 'vue-google-login';
import GoogleSignInButton from 'vue-google-signin-button-directive'

export default {
  directives: {
    GoogleSignInButton
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    ValidationProvider,
    ValidationObserver,
    GoogleLogin
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      params: {
        client_id: "650026417578-2gs56t8uobbhomq1o1e5djabac5dq8b2.apps.googleusercontent.com"
      },
      // only needed if you want to render the button with the google ui
      renderParams: {
        width: 250,
        height: 50,
        longtitle: true
      },
      clientId: '650026417578-2gs56t8uobbhomq1o1e5djabac5dq8b2.apps.googleusercontent.com',
      username: '',
      password: '',
      remember: false,
      sideImg: require("@/assets/images/pages/Meeting.svg"),
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      return this.sideImg
    },
  },
  created() {
    const remember = localStorage.remember;
    this.remember = remember === 'true';
    if (this.remember) {
      this.username = localStorage.username;
      this.password = localStorage.password;
    }

    this.loadFacebookSDK(document, "script", "facebook-jssdk");
    setTimeout(() => {
      this.initFacebook();
    }, 1000)

    const gauthOption = {
      clientId: 'CLIENT_ID.apps.googleusercontent.com',
      scope: 'profile email',
      prompt: 'select_account'
    }
  },
  methods: {
    requestTrial: function () {
      this.$router.push('/pages/login/first-login').catch(() => {
      });
    },
    OnGoogleAuthSuccess(idToken) {
      let that = this;
      // Receive the idToken and make your magic with the backend
      that.$vs.loading();
      that.$business.post('/business-user/create/google', {token: idToken, customerType: 1}).then((response) => {
        if (response.data) {
          that.login(response.data.email, response.data.otp);
        }
      }).catch((err) => {
        that.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      });
    },
    OnGoogleAuthFail(error) {
    },
    async initFacebook() {
      window.FB.init({
        appId: "232787355109246",
        cookie: true,
        version: "v13.0"
      });

    },
    async loadFacebookSDK(d, s, id) {
      let js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    },
    loginAction(evt) {
      evt.preventDefault();
      this.$vs.loading();
      this.login(this.username, this.password);
    },
    login(username, password) {
      localStorage.remember = this.remember;
      if (this.remember) {
        localStorage.username = this.username;
        localStorage.password = this.password;
      } else {
        localStorage.removeItem("username")
        localStorage.removeItem("password")
      }
      this.$store.dispatch('auth/login', {username: username, password: password})
        .then(() => {
          this.$oauth.get('user/current').then((res) => {
            const user = res.data;
            // if(user && user.firstLogin == 0){
            //   this.$router.push('/wizard');
            //   this.$vs.loading.close();
            // }
            // else{
            this.$vs.loading.close();
            this.$eventBus.$emit("login-success", {});
            // }
          })
        })
        .catch(error => {
          this.$vs.loading.close();
          this.$vs.notify({
            text: error.response.data.error_description || 'Lỗi kết nối server',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        });
    },
  },
}
</script>

<style lang="scss">
@import 'src/@core/scss/vue/pages/page-auth.scss';
</style>

<style lang="scss" scoped>
@import 'src/@core/scss/core.scss';
.custom-control.custom-checkbox {
  padding-left: 0px;
}
</style>
